import StencilHTMLElement from "./stencil-element";
import * as THREE from 'three';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';


class ThreeJsCanvas extends StencilHTMLElement {
  name = "ThreeJsCanvas";
  colour;
  finish;
  renderer;
  scene;
  camera;
  shape;

  constructor() {
    super();

    this.colour = this.getAttribute('colour');
    this.finish = this.getAttribute('finish') === "Matte" ? "matte" : "gloss";
  }

  onVariantChanged(e) {
    // all a hack at the moment
    //console.log('var change detail', e.detail);
    if(e.detail.selectedOption.dataset.colour){
      this.colour = e.detail.selectedOption.dataset.colour;
      this.finish = e.detail.variant.option1 === "Matte" ? "matte" : "gloss";

      //console.log('new finish?', this.finish);


      this.shape.material.color.setHex(parseInt(this.colour.replace("#", ""), 16));
      this.shape.material.roughness = this.finish == "matte" ? 100 : 0;
    }
  }

  connectedCallback() {
    document.addEventListener('variant:changed', this.onVariantChanged.bind(this));

    const width = this.firstElementChild.clientWidth;
    const height = 500;
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( 0x929292 );

    this.camera = new THREE.PerspectiveCamera(70, width / height, 10, 100);

    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(width, height);
    this.renderer.setAnimationLoop(this.animateRender.bind(this));
  
    const ambientLight = new THREE.AmbientLight(0x404040);
    this.scene.add(ambientLight);

    const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
    this.scene.environment = pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;

    // const light1 = new THREE.DirectionalLight( 0xffffff, 3 );
    // light1.position.set( 0, 200, 0 );
    // this.scene.add( light1 );

    // const light2 = new THREE.DirectionalLight( 0xffffff, 3 );
    // light2.position.set( 100, 200, 100 );
    // this.scene.add( light2 );

    // const light3 = new THREE.DirectionalLight( 0xffffff, 3 );
    // light3.position.set( - 100, - 200, - 100 );
    // this.scene.add( light3 );
  
    this.firstElementChild.replaceWith(this.renderer.domElement);  
    //const geometry = new THREE.BoxGeometry( 2, 2, 2 );
    const geometry = new THREE.TorusKnotGeometry(10, 3, 200, 32).toNonIndexed();
    const material = new THREE.MeshPhysicalMaterial({ color: parseInt(this.colour.replace("#", ""), 16), roughness: this.finish == "matte" ? 100 : 0 });
    this.shape =  new THREE.Mesh(geometry, material);
    this.scene.add(this.shape);
    
    this.camera.position.z = 35;
  }

  animateRender() {
    this.shape.rotation.x += 0.005;
    this.shape.rotation.y += 0.005; 
    this.renderer.render(this.scene, this.camera);
  }
}

export default ThreeJsCanvas;